import { render } from "./GitlabLogoIcon.vue?vue&type=template&id=517d966f"
import script from "./GitlabLogoIcon.vue?vue&type=script&lang=js"
export * from "./GitlabLogoIcon.vue?vue&type=script&lang=js"

import "./GitlabLogoIcon.vue?vue&type=style&index=0&id=517d966f&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__